import React from 'react';
import styled, { css } from 'styled-components';
import { darkgrey, lightgrey, saveButtonBackgroundColor } from 'styles/Colors';
import { ReactComponent as ImportIcon } from 'images/importIcon.svg';

export const ButtonWrapper = styled.div`
  .input-file + label {
    height: 30px;
    margin-bottom: 0;
  }
`;

export const StyledInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

export const StyledLabel = styled.label<{ disabled?: boolean }>`
  display: flex;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-overflow: ellipsis;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;
  font-family: Oswald, sans-serif;
  color: ${darkgrey};
  background-color: ${saveButtonBackgroundColor};
  border-radius: 4px;
  border-width: 2px;
  height: 40px;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 175px;
  ${(props) =>
    props.disabled &&
    css`
      background-color: ${lightgrey};
      border-color: ${lightgrey};
      cursor: not-allowed;
    `}
`;

export const StyledImportIcon = styled((props) => <ImportIcon {...props} />)`
  margin-right: 11px;
`;
